/**
 * @Author: Li, Yu Jia
 * @Date: 2020-04-30 10:16:45
 * @Last Modified by: Li, Yu Jia
 * @Last Modified time: 2020-04-30 10:17:17
 */

import CopyRight from './CopyRight';

export default CopyRight;
